import { render } from "./Home.vue?vue&type=template&id=00c0fd82"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=00c0fd82&lang=scss"
script.render = render

export default script